import { Control } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Switch } from '@/components/ui/switch';
import type { ExamFormData } from '../utils/examValidation';

interface DentalAssessmentProps {
  control: Control<ExamFormData>;
}

export function DentalAssessment({ control }: DentalAssessmentProps) {
  return (
    <div className="space-y-4">
      {/* Numeric Fields in one row */}
      <div className="grid grid-cols-2 gap-3">
        <FormField
          control={control}
          name="cavities"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-xs">Cavities</FormLabel>
              <FormControl>
                <Input 
                  type="number" 
                  {...field} 
                  onChange={e => field.onChange(Number(e.target.value))}
                  className="h-7 text-sm"
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="missingTeeth"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-xs">Missing Teeth</FormLabel>
              <FormControl>
                <Input 
                  type="number" 
                  {...field} 
                  onChange={e => field.onChange(Number(e.target.value))}
                  className="h-7 text-sm"
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>

      {/* Other Problems Section */}
      <div className="space-y-2">
        <h4 className="text-xs font-medium">Other Problems</h4>
        <div className="grid grid-cols-2 gap-3">
          <FormField
            control={control}
            name="needsCleaning"
            render={({ field }) => (
              <FormItem className="flex items-center justify-between rounded border px-2 py-1">
                <FormLabel className="text-xs font-normal">Professional Cleaning</FormLabel>
                <FormControl>
                  <Switch
                    checked={field.value}
                    onCheckedChange={field.onChange}
                    className="scale-75"
                  />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            control={control}
            name="needsOrthodontics"
            render={({ field }) => (
              <FormItem className="flex items-center justify-between rounded border px-2 py-1">
                <FormLabel className="text-xs font-normal">Orthodontic Treatment</FormLabel>
                <FormControl>
                  <Switch
                    checked={field.value}
                    onCheckedChange={field.onChange}
                    className="scale-75"
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>
      </div>
    </div>
  );
}